import { Guid } from "@/types"

export enum FinanceServiceAssetTypeAvailability {
    inUse = 'InUse',
    available = 'Available'
}
export interface IGetFinanceServiceAssetTypeDto {
    id: Guid
    description: string
}

export class FinanceServiceAssetType {
    id: Guid
    description: string

    constructor(dto: IGetFinanceServiceAssetTypeDto) {
        this.id = dto.id
        this.description = dto.description
    }
}
